'use client';

import { useEffect } from 'react';
import { useIsTrackerReady } from './use-is-tracker-ready';
import { Utag, getUtag } from '../core';

type UseUtagHook = (closure: (utag: Utag) => void, deps?: any[]) => void;

/**
 * Use utag when it's ready.
 *
 * ```tsx
 * useUtag(utag => {
 *   utag.link(...);
 * }, []);
 * ```
 */
export const useUtag: UseUtagHook = (closure, deps) => {
  let trackerReady = useIsTrackerReady();

  useEffect(
    () => {
      if (!trackerReady) {
        return;
      }

      let utag = getUtag(window);

      if (typeof utag === 'undefined') {
        return;
      }

      try {
        closure(utag);
      } catch (e) {
        console.error('Executing utag closure failed.', e);
      }
    },
    deps ? [trackerReady, ...deps] : undefined,
  );

  return;
};
